import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// [honor_rank] http://wiki.xunlei.cn/pages/viewpage.action?pageId=122784132
export enum honor_rank_type {
  cur = 0,
  prev = 1,
}
export const honor_rank = createAsyncThunk(
  '/live/vip/honor_rank',
  async (
    arg: {
      type: honor_rank_type
    },
    store: any
  ) => {
    const resp = await http.post<HiyaRes<InitialStateType['rank']>>(
      '/live/vip/honor_rank',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

// [honor_history] http://wiki.xunlei.cn/pages/viewpage.action?pageId=122785049
export const honor_history = createAsyncThunk(
  '/live/vip/honor_history',
  async (
    arg: {
      date?: string
    },
    store: any
  ) => {
    const resp = await http.post<HiyaRes<InitialStateType>>(
      '/live/vip/honor_history',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

export interface InitialStateType {
  rank?: {
    my_rank?: {
      mid: number
      rank: number
      avatar: string
      name: string
      exp: number
      level: number
      content: string
      stealth: boolean
    }
    month_second?: number
    list?: Array<{
      mid: number
      rank: number
      avatar: string
      name: string
      exp: number
      level: number
      icon: string
      stealth: boolean
    }>
  }
  honor: {
    left_date?: string
    current_date?: string
    right_date?: string
    list?: Array<{
      mid: number
      avatar: string
      name: string
      level: number
      icon: string
      stealth?: boolean
    }>
  }
}

const initialState: InitialStateType = {
  rank: {},
  honor: {},
}

export const VipHonorSlice = createSlice({
  name: 'VipHonorSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(honor_rank.fulfilled, (state, action) => {
      Object.assign(state.rank, action.payload)
    })
    builder.addCase(honor_history.fulfilled, (state, action) => {
      Object.assign(state.honor, action.payload)
    })
  },
})
export default VipHonorSlice.reducer
export const VipHonorActions = VipHonorSlice.actions

export const useVipHonorState = () => {
  const data = useSelector((state) => {
    return state.VipHonor
  })
  return data
}
